import React from "react";

const PageHeader = (props) => {
  return <div {...props}>{props.extra}</div>;
};

export { PageHeader };
